export const GALLERY_ACCESS_STORAGE_KEY = "gallery_access_token";

export function readGalleryAccessToken() {
  if (typeof window === "undefined") return null;
  return window.sessionStorage.getItem(GALLERY_ACCESS_STORAGE_KEY);
}